import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { MeshCompNodeDeps } from './mesh.types'
import {
	createMeshContainer,
	getMeshForColumns,
	getMeshForContainer,
	getMeshForHoverBox,
	getMeshForMasterPage,
	shouldCalculateMesh,
} from './meshCompNodeHelpers'

export const mesh = (isEditor: boolean) =>
	createCssCompNode('mesh', 'mesh', {
		getDependencies: (component, refs: FeatureRefs<'mesh'>) => {
			if (!shouldCalculateMesh(component)) {
				return null
			}

			const compData = {
				props: refs.propertyQuery(component.propertyQuery!),
				style: refs.styleId(component.styleId!),
				data: refs.dataQuery(component.dataQuery!),
			}

			const siteHeader = component.componentType === 'MasterPage' ? refs.meshChild('SITE_HEADER') : undefined
			return {
				children: (component.components || []).map(refs.meshChild),
				compData,
				siteHeader,
				isMobileView: envRefs.isMobileView,
				siteWidth: envRefs.siteWidth,
				autoHeightWrapper: isEditor ? refs.autoHeightWrapper?.(component) : false,
				absoluteComps: envRefs.meshRuntimeData_absoluteComps,
				isMesh2ExperimentOpen: envRefs.experiment('specs.thunderbolt.mesh2'),
			}
		},
		toViewItem: (component, deps) => {
			if (!deps) {
				return null
			}

			if (component.componentType === 'MasterPage') {
				return { meshResults: [getMeshForMasterPage(component, deps as MeshCompNodeDeps)] }
			}

			if (component.componentType === 'StripColumnsContainer') {
				return getMeshForColumns(component, deps as MeshCompNodeDeps)
			}

			if (component.componentType === 'HoverBox') {
				return getMeshForHoverBox(component, deps as MeshCompNodeDeps)
			}

			if (component.componentType === 'PopupContainer' || component.componentType === 'Page') {
				const newContainer = createMeshContainer(component, deps as MeshCompNodeDeps)

				return { meshResults: [getMeshForContainer(newContainer, deps as MeshCompNodeDeps)] }
			}

			return { meshResults: [getMeshForContainer(component, deps as MeshCompNodeDeps)] }
		},
	})
